// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__u5gg+","copy":"Footer_copy__Ws--o","social":"Footer_social__ZLhSK","link":"Footer_link__c5ir1"};